import { PermissionType } from '@cbinsights/adminpermissionservice/adminpermissionservice';
import { dataFeedPermissions } from 'client/modules/data-feed-credit/permissions';
import { TeamDataFeedList } from 'client/modules/data-feeds/containers/TeamDataFeedList';
import useHasAccess from 'client/utils/permissions-validation/hooks/useHasAccess';

type Props = {
  idTeam: number;
};

const DataFeedsV2 = ({ idTeam }: Props) => {
  const hasAccessToDataFeed = useHasAccess({
    pageId: dataFeedPermissions.pageId,
    permissionType: PermissionType.PUBLISH,
  });
  if (!hasAccessToDataFeed) {
    return (
      <div className="text-center">
        You do not have permission to view this tab.
      </div>
    );
  }
  return <TeamDataFeedList idTeam={idTeam} />;
};

export default DataFeedsV2;
